import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { PIPELINE_PATHS } from "~/team/constants/paths.constants";

export function InterviewNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Interview not found</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            The interview you&apos;re looking for isn't available. View all interviews to find what you need, or try
            reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamInterviewNotFound() {
  return (
    <InterviewNotFound>
      <ButtonLink variant="default" to={PIPELINE_PATHS.interviews()}>
        View Interviews
      </ButtonLink>
    </InterviewNotFound>
  );
}
